import { Button, Dialog, DialogActions, DialogBody, DialogDescription, DialogTitle } from '@criteria-labs/react'
import openAPITemplate from '../../templates/openapi'
import petstore3_0Template from '../../templates/petstore3_0'
import petstore3_1Template from '../../templates/petstore3_1'
import readmeTemplate from '../../templates/readme'
import schemaTemplate from '../../templates/schema'
import spectralTemplate from '../../templates/spectral'

export function ChooseTemplateDialog({
  open,
  onClose,
  onChooseTemplate
}: {
  open: boolean
  onClose: (open: boolean) => void
  onChooseTemplate: (fileData: { name: string; text: string }) => void
}) {
  return (
    <Dialog open={open} onClose={onClose} size="3xl">
      <DialogTitle>New File</DialogTitle>
      <DialogDescription>Choose a template for your new file:</DialogDescription>
      <DialogBody>
        <div className="grid w-full grid-cols-3 gap-6">
          <h3 className="col-span-full text-sm/6">API</h3>
          <Button outline className="h-16" onClick={() => onChooseTemplate(openAPITemplate)}>
            OpenAPI Document
          </Button>
          <Button outline className="h-16" onClick={() => onChooseTemplate(petstore3_0Template)}>
            Swagger Petstore (3.0)
          </Button>
          <Button outline className="h-16" onClick={() => onChooseTemplate(petstore3_1Template)}>
            Swagger Petstore (3.1)
          </Button>
          <h3 className="col-span-full text-sm/6">Schema</h3>
          <Button outline className="h-16" onClick={() => onChooseTemplate(schemaTemplate)}>
            JSON Schema Document
          </Button>
          <h3 className="col-span-full text-sm/6">Style Guide</h3>
          <Button outline className="h-16" onClick={() => onChooseTemplate(spectralTemplate)}>
            Spectral Ruleset
          </Button>
          <h3 className="col-span-full text-sm/6">Markdown</h3>
          <Button outline className="h-16" onClick={() => onChooseTemplate(readmeTemplate)}>
            Readme
          </Button>
        </div>
      </DialogBody>
      <DialogActions>
        <Button plain onClick={() => onClose(false)}>
          Cancel
        </Button>
      </DialogActions>
    </Dialog>
  )
}
